import { connect, FieldArray } from 'formik';
import { Guid } from 'guid-typescript';
import { Log } from 'ng2-logger';
import React, { Component } from 'react';
import { DatetimeFormik } from '../../../../components/input/date-time/date-time-formik';
import { Quil } from '../../../../components/input/quil/main';
import { SelectAsync, SelectNoneAsync } from '../../../../components/input/select/main';
import Input from '../../../../components/input/text/input-formik';
import Translator from '../../../../core/i18n';
import { IFormikProps, IOuterProps, IProjectActivityAddProps } from '../../../../models/components/add-activity-project-content';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import { ActivityTypeEnums } from '../../../../models/enums/ActivityType';
import { GlobalState } from '../../../../models/action/core.d';
import FileUpload from '../../../../components/file-upload/main';
import { Confirm } from '../../../../components/notification/main';
import { VirtualClassType } from '../../../../models/enums/VirtualClassType';
import { Common } from '../../../../core/common';
import Tooltip from '../../../../components/tooltip/main';

const T = Translator.create();
const _logger = Log.create('profile-tabpanel');

let _common: Common;

export class DocumentActivityContent extends Component<IFormikProps, any> {
    _deletedFilesId = this.props.formik.values.deletedFilesId;

    constructor(props: any) {
        super(props);
        this.deleteVideo = this.deleteVideo.bind(this);
        _common = new Common();

        this.state = {
            sub_activities: [
                {
                    id: Guid.create().toString(),
                    activityType: 0,
                    deadline: '',
                    deadlineTime: ''
                }
            ],
            activityType: 0,
            activityInitialValues: {},
            filesCount: 0,
            selectComponentKey: Guid.create().toString(),
            isModelOpen: false
        };
    }

    componentDidMount() {
        if (this.props.formik.values.file && this.props.formik.values.file.length) {
            this.setState({ filesCount: this.props.formik.values.file.length });
        }
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (this.state.activityType !== prevState.activityType) {
            this.setState({
                activityInitialValues: this.defaultValueForActivity(this.state.activityType)
            });
        }

        if (this.props.isGroupProject !== prevProps.isGroupProject) {
            this.setState({ selectComponentKey: Guid.create().toString() });
        }
    }

    defaultValueForActivity = (activityType: ActivityTypeEnums) => {
        switch (activityType) {
            case ActivityTypeEnums.Assignment:
                return GlobalState().assignment.AssignmentData;
            case ActivityTypeEnums.Document:
                return GlobalState().document.DocumentData;
            case ActivityTypeEnums.Forum:
                return GlobalState().forum.forumData;
            case ActivityTypeEnums.VirtualClass:
                return GlobalState().virtualClass.VirtualClassData;
            case ActivityTypeEnums.Video:
                return GlobalState().video.videoData;
            default:
                return null;
        }
    };

    updateActivityType = (e: any, _activity: any) => {
        const updatedList = this.state.sub_activities.map((activity: any) =>
            activity.hashedProjectActivityId === _activity.hashedProjectActivityId
                ? { id: activity.hashedProjectActivityId, activityType: e.value ? e.value : 0, deadline: activity.deadline }
                : activity
        );

        this.setState({
            sub_activities: updatedList
        });
    };

    updateActivityDeadline = (e: any, _activity: any) => {
        const updatedList = this.state.sub_activities.map((activity: any) =>
            activity.hashedProjectActivityId === _activity.hashedProjectActivityId
                ? { id: activity.hashedProjectActivityId, activityType: activity.activityType, deadline: e.value ? e.value : '' }
                : activity
        );

        this.setState({
            sub_activities: updatedList
        });
    };

    public deleteVideo() {
        this.props.formik.setFieldValue('isDocumentDeleted', true);
    }

    public onClickDeleteFile = (fileId: string, fileName: string) => {
        Confirm.setConfirm('normal', () => this.deleteFile(fileId, fileName), T.t('r_delete_file_question'), null);
    };

    public timingControl = (type: number) => {
        this.props.formik.values.dateCriteria === type ?
            this.props.formik.setFieldValue('dateCriteria', -1) :
            this.props.formik.setFieldValue('dateCriteria', type);
    }

    public deleteFile = (fileId: string, fileName: string) => {
        this.setState({ isModelOpen: true });
        this._deletedFilesId.push(fileId);
        this.props.formik.setFieldValue('deletedFilesId', this._deletedFilesId);
        const fileDiv = document.getElementById(fileName);
        if (fileDiv) {
            fileDiv.classList.add(...['fadeOut', 'animated', 'hide']);
            setTimeout(() => {
                if (fileDiv.parentNode) fileDiv.parentNode.removeChild(fileDiv);
            }, 1000);
        }
        this.setState({ filesCount: this.state.filesCount - 1 });
    };

    public clickToDownload = (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();
        if (filepath && fileName) {
            _common.DownloadLink(filepath + '/download', fileName);
        }
    };

    handleDatePrerequisiteActivityId = (selectedValue: any) => {
        this.props.formik.setFieldValue('datePrerequisiteActivityId', selectedValue.value);
        this.props.formik.values.datePrerequisiteActivityId = selectedValue.value;
    }

    public render() {
        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_contentTab' ? ' show active' : '')}
                style={{ display: this.props.currentTab === '_contentTab' ? 'block' : 'none' }}
                id="video-setting"
                role="tabpanel"
                aria-labelledby="video-setting-tab"
            >
                 <h5 className="input-label mx-0">{T.t('r_activity_search_placeholder')}<span className="ml-1" style={{ color: '#dc5050' }}>*</span></h5>
                <Input type={'text'} name={'name'} placeHolder={T.t('r_write_name_activity')} formik={this.props.formik} />
                <p className="half-color">{T.t('r_activity_list_shown_text')}</p>
                 <h5 className="input-label mx-0">{T.t('r_Instructor_note_description')}</h5>
                <Quil
                    modules={'basic'}
                    placeholder={T.t('r_write_description_for_activity')}
                    // tslint:disable-next-line
                    onChange={(e: any) => this.props.formik.setFieldValue('description', e)}
                    value={this.props.formik.values.description}
                    theme={'snow'}
                />
                {/*  <h5 className="input-label mx-0">{T.t('r_fileUpload_dashboardTitle')}</h5> */}
                {this.props.formik.values.file && this.state.isModelOpen === false ? '' : <> <h5 className="input-label mx-0">{T.t('r_fileUpload_dashboardTitle')}</h5>
                    <div className="upload-image text-center mb-1">
                        <FileUpload
                            key={this.props.fileInputKey}
                            fileInputKey={this.props.fileInputKey}
                            height={300}
                            maxFileSize={2000000000}
                            maxSelectedFileCount={1}
                            isCardImage={false}
                            modalOpen={this.state.isModelOpen}
                            activityType={ActivityTypeEnums.Project}
                            files={this.props.formik.values.file}
                        />
                    </div></>
                }
                {this.props.formik.values.file &&
                    this.props.formik.values.file.map((file: any) => {
                        return (
                            <div
                                key={file.fileName}
                                id={file.fileName}
                                className="row"
                                style={{ paddingLeft: '15px', paddingRight: '15px', marginTop: '10px' }}
                            >
                                <p>
                                    <b>{T.t('r_file')} </b>
                                    <a
                                        target="_blank"
                                        title={file.fileName}
                                        style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: '90%'
                                        }}
                                        onClick={this.clickToDownload}
                                        data-filepath={file && file.filePath}
                                        data-filename={file && file.fileName}
                                    >
                                        {file.fileName}
                                    </a>
                                </p>
                                <i
                                    onClick={this.onClickDeleteFile.bind(this, file.fileId, file.fileName)}
                                    className="material-icons del-icon del-icon-color"
                                    style={{ marginLeft: 'auto', cursor: 'pointer' }}
                                >
                                    delete
                                </i>
                            </div>
                        );
                    })}
                 <h5 className="input-label mx-0">{T.t('r_sub_activities')}</h5>
                <div className="row">
                    <div className="col-md-12">
                        <FieldArray
                            name="subActivities"
                            render={(arrayHelpers: any) => {
                                return (
                                    <React.Fragment>
                                        <div className="row">
                                            <div className="col-md-5 pull-left">
                                                <SelectNoneAsync
                                                    name={`activityType`}
                                                    key={this.state.selectComponentKey}
                                                    setFieldValue={this.state.activityType}
                                                    setOptions={[
                                                        { value: ActivityTypeEnums.Assignment, label: T.t('r_activity_type_Assignment') },
                                                        { value: ActivityTypeEnums.Document, label: T.t('r_activity_type_Document') },
                                                        { value: ActivityTypeEnums.Forum, label: T.t('r_activity_type_Forum') },
                                                        ...(this.props.isGroupProject
                                                            ? [
                                                                {
                                                                    value: ActivityTypeEnums.VirtualClass,
                                                                    label: T.t('r_activity_type_VirtualClass')
                                                                }
                                                            ]
                                                            : []),
                                                        { value: ActivityTypeEnums.Video, label: T.t('r_activity_type_Video') }
                                                    ]}
                                                    // tslint:disable-next-line:jsx-no-lambda
                                                    onChange={(e: any) =>
                                                        this.setState({
                                                            activityType: e ? e.value : null
                                                        })
                                                    }
                                                    isTouched={this.props.formik.setFieldTouched}
                                                    setSelectValue={
                                                        this.props.isUpdate
                                                            ? [
                                                                {
                                                                    value: ActivityTypeEnums.Assignment,
                                                                    label: T.t('r_activity_type_Assignment')
                                                                }
                                                            ]
                                                            : null
                                                    }
                                                    placeHolder={T.t('r_make_select')}
                                                />
                                            </div>
                                            <button
                                                type="button"
                                                disabled={!this.state.activityType}
                                                className="category-tag-square tag-gray"
                                                id="activityadd"
                                                onClick={() => {
                                                    this.state.activityType &&
                                                        arrayHelpers.push({
                                                            hashedProjectActivityId: Guid.create().toString(),
                                                            activityType: this.state.activityType,
                                                            deadline: '',
                                                            deadlineTime: '',
                                                            ...this.state.activityInitialValues
                                                        });
                                                }}
                                            >
                                                <i className="material-icons mr-2">add</i>{' '}
                                                {T.t('r_user_home_calendar_teacher_add_activity')}
                                            </button>
                                        </div>

                                        {this.props.formik.values.subActivities.map((activity: any, index: any) => (
                                            <div
                                                className="white-boxs activitycontent"
                                                style={{ display: 'flex', alignItems: 'baseline' }}
                                                key={activity.hashedProjectActivityId}
                                            >
                                                <div className="row">
                                                    <div className="col-md-11">
                                                        <h5 className="mt-2">
                                                            {T.t(`r_activity_type_${ActivityTypeEnums[activity.activityType]}`)}
                                                        </h5>
                                                    </div>
                                                    <div className="col-md-1 pull-right">
                                                        <a id="activitydelete" onClick={() => arrayHelpers.remove(index)}>
                                                            <i className="material-icons m-t-24 mr-2 i-alert pull-right">delete</i>
                                                        </a>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <Input
                                                            type={'text'}
                                                            className={'form-input form-group'}
                                                            name={`subActivities[${index}].name`}
                                                            placeHolder={T.t('r_write_name_activity')}
                                                            formik={this.props.formik}
                                                        />
                                                    </div>
                                                    {ActivityTypeEnums[activity.activityType] === 'Assignment' && (
                                                        <React.Fragment>
                                                            <div className="col-md-12 mt-2">
                                                                <h6>{T.t('r_last_date')}</h6>
                                                            </div>
                                                            <div className="col-md-6 pull-left">
                                                                <div className="form-input form-group date-picker">
                                                                    <DatetimeFormik
                                                                        name={`subActivities[${index}].deadline`}
                                                                        dateFormat={this.props.dateFormat}
                                                                        formik={this.props.formik}
                                                                        // onChange={(e: any) => this.updateActivityDeadline(e, activity)}
                                                                        placeHolder={T.t('r_last_date')}
                                                                        datePickerId={
                                                                            'activity_deadline-' + activity.hashedProjectActivityId
                                                                        }
                                                                        mode="single"
                                                                        static={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 pull-left">
                                                                <div className="form-input form-group date-picker">
                                                                    <DatetimeFormik
                                                                        name={`subActivities[${index}].deadlineTime`}
                                                                        formik={this.props.formik}
                                                                        datePickerId={
                                                                            'activity_deadlineTime-' + activity.hashedProjectActivityId
                                                                        }
                                                                        placeHolder={T.t('r_time')}
                                                                        mode="time"
                                                                        time24Hr={true}
                                                                        static={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )}

                                                    {ActivityTypeEnums[activity.activityType] === 'VirtualClass' && (
                                                        <React.Fragment>
                                                            <h6 className="mt-2 ml-3">{T.t('r_virtual_class_type')}</h6>
                                                            <div className="ml-3 mr-3" style={{ width: '100%' }}>
                                                                <SelectNoneAsync
                                                                    name={`subActivities[${index}].virtualClassType`}
                                                                    touched={this.props.formik.touched.virtualClassType}
                                                                    errors={this.props.formik.errors.virtualClassType}
                                                                    setFieldValue={this.props.formik.setFieldValue}
                                                                    setOptions={[
                                                                        { value: VirtualClassType.Perculus, label: 'Perculus' },
                                                                        { value: VirtualClassType.PerculusPlus, label: 'Perculus Plus' }
                                                                    ]}
                                                                    // tslint:disable-next-line:jsx-no-lambda
                                                                    onChange={(e: any) =>
                                                                        this.props.formik.setFieldValue(
                                                                            `subActivities[${index}].virtualClassType`,
                                                                            e ? e.value : null
                                                                        )
                                                                    }
                                                                    isTouched={this.props.formik.setFieldTouched}
                                                                    setSelectValue={
                                                                        this.props.isUpdate ? [activity.virtualClassType] : null
                                                                    }
                                                                    placeHolder={T.t('r_make_select')}
                                                                />
                                                            </div>
                                                            <div className="col-md-12 mt-4">
                                                                <h6>{T.t('r_start_time')}</h6>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-input form-group date-picker mb-md-0">
                                                                    <DatetimeFormik
                                                                        name={`subActivities[${index}].actualStartTime`}
                                                                        dateFormat={this.props.dateFormat}
                                                                        formik={this.props.formik}
                                                                        placeHolder={T.t('r_datetime_picker_date')}
                                                                        datePickerId={
                                                                            'addActualStartTime-' + activity.hashedProjectActivityId
                                                                        }
                                                                        mode="single"
                                                static={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-input form-group date-picker mb-md-0 ml-md-4 mr-md-4">
                                                                    <DatetimeFormik
                                                                        name={`subActivities[${index}].startTimeHour`}
                                                                        formik={this.props.formik}
                                                                        datePickerId={
                                                                            'addStartTimeHour-' + activity.hashedProjectActivityId
                                                                        }
                                                                        placeHolder={T.t('r_time')}
                                                                        mode="time"
                                                                        time24Hr={true}
                                                                        static={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <Input
                                                                    type={'number'}
                                                                    className="form-input form-group date-picker mb-md-0"
                                                                    name={`subActivities[${index}].virtualClassTime`}
                                                                    label={T.t('r_validation_gen_virtualClassTime')}
                                                                    placeHolder={T.t('r_type_the_time')}
                                                                    formik={this.props.formik}
                                                                />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <Input
                                                                    type={'number'}
                                                                    className="form-input form-group date-picker mb-md-0 ml-md-4 mr-md-4"
                                                                    name={`subActivities[${index}].preparationTime`}
                                                                    label={T.t('r_validation_gen_preparationTime')}
                                                                    placeHolder={T.t('r_type_the_time')}
                                                                    formik={this.props.formik}
                                                                />
                                                            </div>
                                                        </React.Fragment>
                                                    )}
                                                    <div className="col-md-12 mt-4 mb-1">
                                                        <h6>{T.t('r_activity_finish_criteria')}</h6>
                                                    </div>
                                                    {ActivityTypeEnums[activity.activityType] === 'Document' && (
                                                        <div className="col-md-6">
                                                            <div className="radio-tabs tick-radio position-relative">
                                                                <input
                                                                    type="radio"
                                                                    name={`subActivities[${index}].completionType`}
                                                                    value={ActivityCompletionType.View}
                                                                    defaultChecked={true}
                                                                    onChange={this.props.formik.setFieldValue.bind(
                                                                        this,
                                                                        `subActivities[${index}].completionType`,
                                                                        ActivityCompletionType.View
                                                                    )}
                                                                    id={'activity-one-' + activity.hashedProjectActivityId}
                                                                    className="form-radio"
                                                                    checked={
                                                                        activity.completionType === ActivityCompletionType.View
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <label htmlFor={'activity-one-' + activity.hashedProjectActivityId}>
                                                                    {T.t('r_display')}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {ActivityTypeEnums[activity.activityType] === 'Forum' && (
                                                        <React.Fragment>
                                                            <div className="col-md-4">
                                                                <div className="radio-tabs tick-radio position-relative">
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.View}
                                                                        defaultChecked={true}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.View
                                                                        )}
                                                                        id={'completion-type-view-' + activity.hashedProjectActivityId}
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType === ActivityCompletionType.View
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <label
                                                                        htmlFor={'completion-type-view-' + activity.hashedProjectActivityId}
                                                                    >
                                                                        {T.t('r_display')}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.ComposeMessage}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.ComposeMessage
                                                                        )}
                                                                        id={
                                                                            'completion-type-composemessage-' +
                                                                            activity.hashedProjectActivityId
                                                                        }
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType ===
                                                                            ActivityCompletionType.ComposeMessage
                                                                        }
                                                                    />
                                                                    <label
                                                                        htmlFor={
                                                                            'completion-type-composemessage-' +
                                                                            activity.hashedProjectActivityId
                                                                        }
                                                                    >
                                                                        {T.t('r_gen_compose_message')}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.WordCount}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.WordCount
                                                                        )}
                                                                        id={'completion-type-wordcount-' + activity.hashedProjectActivityId}
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType === ActivityCompletionType.WordCount
                                                                        }
                                                                    />
                                                                    <label
                                                                        htmlFor={
                                                                            'completion-type-wordcount-' + activity.hashedProjectActivityId
                                                                        }
                                                                    >
                                                                        {T.t('r_gen_word_count')}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div
                                                                    className={
                                                                        'animated ' +
                                                                        (activity.completionType === ActivityCompletionType.WordCount
                                                                            ? 'fadeInDown'
                                                                            : 'fadeOutDown')
                                                                    }
                                                                    style={{
                                                                        animationDuration: '0.3s',
                                                                        display:
                                                                            activity.completionType === ActivityCompletionType.WordCount
                                                                                ? 'block'
                                                                                : 'none',
                                                                        marginTop: '1.5rem'
                                                                    }}
                                                                >
                                                                    <Input
                                                                        type={'number'}
                                                                        placeHolder={T.t('r_gen_word_count')}
                                                                        name={`subActivities[${index}].completionCriteria`}
                                                                        min={0}
                                                                        formik={this.props.formik}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )}
                                                    {ActivityTypeEnums[activity.activityType] === 'Video' && (
                                                        <React.Fragment>
                                                            <div className="col-md-4">
                                                                <div className="radio-tabs tick-radio position-relative">
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.View}
                                                                        defaultChecked={true}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.View
                                                                        )}
                                                                        id={'activity-one-' + activity.hashedProjectActivityId}
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType === ActivityCompletionType.View
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <label htmlFor={'activity-one-' + activity.hashedProjectActivityId}>
                                                                        {T.t('r_display')}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.Grade}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.Grade
                                                                        )}
                                                                        id={'activity-three-' + activity.hashedProjectActivityId}
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType === ActivityCompletionType.Grade
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <label htmlFor={'activity-three-' + activity.hashedProjectActivityId}>
                                                                        {T.t('r_noted')}
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className={
                                                                        'animated ' +
                                                                        (activity.completionType === ActivityCompletionType.Grade
                                                                            ? 'fadeInDown'
                                                                            : 'fadeOutDown')
                                                                    }
                                                                    style={{
                                                                        animationDuration: '0.3s',
                                                                        display:
                                                                            activity.completionType === ActivityCompletionType.Grade
                                                                                ? 'block'
                                                                                : 'none',
                                                                        marginTop: '1.5rem'
                                                                    }}
                                                                >
                                                                    <Input
                                                                        type={'text'}
                                                                        name={`subActivities[${index}].completionCriteria`}
                                                                        label={T.t('r_grade')}
                                                                        formik={this.props.formik}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.Progress}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.Progress
                                                                        )}
                                                                        id={'activity-two-' + activity.hashedProjectActivityId}
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType === ActivityCompletionType.Progress
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <label htmlFor={'activity-two-' + activity.hashedProjectActivityId}>
                                                                        {T.t('r_gen_progress')}
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className={
                                                                        'animated ' +
                                                                        (activity.completionType === ActivityCompletionType.Progress
                                                                            ? 'fadeInDown'
                                                                            : 'fadeOutDown')
                                                                    }
                                                                    style={{
                                                                        animationDuration: '0.3s',
                                                                        display:
                                                                            activity.completionType === ActivityCompletionType.Progress
                                                                                ? 'block'
                                                                                : 'none',
                                                                        marginTop: '1.5rem'
                                                                    }}
                                                                >
                                                                    <Input
                                                                        type={'text'}
                                                                        name={`subActivities[${index}].completionCriteria`}
                                                                        label={T.t('r_gen_progress')}
                                                                        formik={this.props.formik}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )}
                                                    {ActivityTypeEnums[activity.activityType] === 'Assignment' && (
                                                        <React.Fragment>
                                                            <div className="col-md-4">
                                                                <div className="radio-tabs tick-radio position-relative">
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.View}
                                                                        defaultChecked={true}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.View
                                                                        )}
                                                                        id={'activity-one-' + activity.hashedProjectActivityId}
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType === ActivityCompletionType.View
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <label htmlFor={'activity-one-' + activity.hashedProjectActivityId}>
                                                                        {T.t('r_display')}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.Grade}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.Grade
                                                                        )}
                                                                        id={'activity-two-' + activity.hashedProjectActivityId}
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType === ActivityCompletionType.Grade
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <label htmlFor={'activity-two-' + activity.hashedProjectActivityId}>
                                                                        {T.t('r_noted')}
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className={
                                                                        'animated ' +
                                                                        (activity.completionType === ActivityCompletionType.Grade
                                                                            ? 'fadeInDown'
                                                                            : 'fadeOutDown')
                                                                    }
                                                                    style={{
                                                                        animationDuration: '0.3s',
                                                                        display:
                                                                            activity.completionType === ActivityCompletionType.Grade
                                                                                ? 'block'
                                                                                : 'none',
                                                                        marginTop: '1.5rem'
                                                                    }}
                                                                >
                                                                    <Input
                                                                        type={'text'}
                                                                        name={`subActivities[${index}].completionCriteria`}
                                                                        label={T.t('r_grade')}
                                                                        formik={this.props.formik}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.Upload}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.Upload
                                                                        )}
                                                                        id={'activity-three-' + activity.hashedProjectActivityId}
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType === ActivityCompletionType.Upload
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <label htmlFor={'activity-three-' + activity.hashedProjectActivityId}>
                                                                        {T.t('r_upload_file')}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )}
                                                    {ActivityTypeEnums[activity.activityType] === 'VirtualClass' && (
                                                        <React.Fragment>
                                                            <div className="col-md-6">
                                                                <div className="radio-tabs tick-radio position-relative">
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.AttendLiveSession}
                                                                        defaultChecked={true}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.AttendLiveSession
                                                                        )}
                                                                        id={'activity-one-' + activity.hashedProjectActivityId}
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType ===
                                                                                ActivityCompletionType.AttendLiveSession
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <label htmlFor={'activity-one-' + activity.hashedProjectActivityId}>
                                                                        {T.t('r_activity_virtualClass_attend_live_session')}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="radio-tabs tick-radio position-relative">
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.ViewRecordedSession}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.ViewRecordedSession
                                                                        )}
                                                                        id={'activity-two-' + activity.hashedProjectActivityId}
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType ===
                                                                                ActivityCompletionType.ViewRecordedSession
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <label htmlFor={'activity-two-' + activity.hashedProjectActivityId}>
                                                                        {T.t('r_activity_virtualClass_view_recorded_session')}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mt-3">
                                                                <div
                                                                    className="radio-tabs tick-radio position-relative"
                                                                    style={{ marginRight: '0' }}
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.ProgressLive}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.ProgressLive
                                                                        )}
                                                                        id={'activity-three-' + activity.hashedProjectActivityId}
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType === ActivityCompletionType.ProgressLive
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <label htmlFor={'activity-three-' + activity.hashedProjectActivityId}>
                                                                        {T.t('r_activity_virtualClass_progress_live')}
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className={
                                                                        'animated ' +
                                                                        (activity.completionType === 9 ? 'fadeInDown' : 'fadeOutDown')
                                                                    }
                                                                    style={{
                                                                        animationDuration: '0.3s',
                                                                        display: activity.completionType === 9 ? 'block' : 'none',
                                                                        padding: '1.8%'
                                                                    }}
                                                                >
                                                                    <Input
                                                                        type={'number'}
                                                                        name={`subActivities[${index}].completionCriteria`}
                                                                        label={T.t('r_gen_progress')}
                                                                        formik={this.props.formik}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6 mt-3">
                                                                <div
                                                                    className="radio-tabs tick-radio position-relative"
                                                                    style={{ marginRight: '0' }}
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        name={`subActivities[${index}].completionType`}
                                                                        value={ActivityCompletionType.ProgressLiveOrArchive}
                                                                        onChange={this.props.formik.setFieldValue.bind(
                                                                            this,
                                                                            `subActivities[${index}].completionType`,
                                                                            ActivityCompletionType.ProgressLiveOrArchive
                                                                        )}
                                                                        id={'activity-four-' + activity.hashedProjectActivityId}
                                                                        className="form-radio"
                                                                        checked={
                                                                            activity.completionType ===
                                                                                ActivityCompletionType.ProgressLiveOrArchive
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <label htmlFor={'activity-four-' + activity.hashedProjectActivityId}>
                                                                        {T.t('r_activity_virtualClass_progress_live_or_archive')}
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className={
                                                                        'animated ' +
                                                                        (activity.completionType === 10 ? 'fadeInDown' : 'fadeOutDown')
                                                                    }
                                                                    style={{
                                                                        animationDuration: '0.3s',
                                                                        display: activity.completionType === 10 ? 'block' : 'none',
                                                                        padding: '1.8%'
                                                                    }}
                                                                >
                                                                    <Input
                                                                        type={'number'}
                                                                        name={`subActivities[${index}].completionCriteria`}
                                                                        label={T.t('r_gen_progress')}
                                                                        formik={this.props.formik}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </React.Fragment>
                                );
                            }}
                        />
                    </div>
                </div>
                <div className='d-flex align-items-center mt-2'>
                     <h5 className="input-label mx-0">{T.t('r_timing')}</h5>

                    <Tooltip data={T.t('r_timing_info')} position='top'heightValue='2em'>
                        <img src={_common.GetDefaultIcons('info')} style={{ width: '1em',height:'1em', marginInlineStart: "8px" }} alt="" />
                    </Tooltip>
                </div>
                <div className="row">
                    {this.props.isWeekly && (
                        <div className="col-md-4">
                            <div className="radio-tabs tick-radio position-relative">
                                <input
                                    type="checkbox"
                                    name={'dateCriteria'}
                                    onChange={this.timingControl.bind(this, 0)}
                                    value={0}
                                    id="time-zero"
                                    className="form-radio"
                                    checked={this.props.formik.values.dateCriteria === 0 ? true : false}
                                    style={{ borderRadius: 100 }}
                                />
                                <label htmlFor="time-zero" style={{ marginInlineStart: "6px" }}>
                                    {T.t('r_show_by').replace('{0}', this.props.termType)}
                                </label>
                            </div>
                        </div>
                    )}
                    <div className="col-md-4">
                        <div className="radio-tabs tick-radio position-relative">
                            <input
                                type="checkbox"
                                name={'dateCriteria'}
                                onChange={this.timingControl.bind(this, 1)}
                                value={1}
                                id="time-one"
                                className="form-radio"
                                checked={this.props.formik.values.dateCriteria === 1 ? true : false}
                                style={{ borderRadius: 100 }}
                            />
                            <label htmlFor="time-one" style={{ marginInlineStart: "6px" }}>{T.t('r_publish_by_date')}</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                            <input
                                type="checkbox"
                                name={'dateCriteria'}
                                onChange={this.timingControl.bind(this, 2)}
                                value={2}
                                id="time-two"
                                className="form-radio"
                                checked={this.props.formik.values.dateCriteria === 2 ? true : false}
                                style={{ borderRadius: 100 }}
                            />
                            <label htmlFor="time-two" style={{ marginInlineStart: "6px" }}>{T.t('r_show_by_another_activity')}</label>
                        </div>
                    </div>
                </div>
                <div className="row" id="project_publish_date" style={{ marginTop: 0 }}>
                    <div className="col-md-6">
                        <div
                            style={{
                                display: this.props.formik.values.dateCriteria === 1 ? 'block' : 'none'
                            }}
                        >
                            <DatetimeFormik
                                name={'dateRange'}
                                placeHolder={T.t('r_datetime_picker_date')}
                                dateFormat={this.props.dateFormat}
                                formik={this.props.formik}
                                datePickerId={'addActivityDateRange'}
                                mode="range"
                                time24Hr={true}
                                static={true}
                            />
                        </div>
                        <div
                            className={'animated ' + (this.props.formik.values.dateCriteria === 0 ? 'fadeInDown' : 'fadeOutDown')}
                            style={{
                                animationDuration: '0.3s',
                                display: this.props.formik.values.dateCriteria === 0 ? 'block' : 'none',
                            }}
                        >
                            {this.props.isWeekly ? (
                                <SelectAsync
                                    isMulti={true}
                                    isSearchable={true}
                                    requestType={'post'}
                                    isDisabled={!this.props.isWeekly}
                                    parameter={{
                                        courseId: this.props.coursePageActivityId,
                                        classId: this.props.coursePageClassId,
                                        isTiming: true,
                                        SelectedIds: this.props.formik.values.termWeekIds,
                                        activityConditionalBeginDate: this.props.formik.values.activityConditionalBeginDate
                                    }}
                                    placeHolder={T.t('r_select_by').replace('{0}', this.props.termType)}
                                    url={'api/term/courseweeks'}
                                    closeMenuOnScroll={false}
                                    closeMenuOnSelect={false}
                                    column={{ label: 'weekLabel', value: 'termWeekId' }}
                                    setSelectValue={this.props.isUpdate ? this.props.formik.values.termWeekIds : ''}
                                    name={'termWeekIds'}
                                    value={this.props.formik.values.termWeekIds}
                                    onChange={this.props.formik.handleChange}
                                    setFieldValue={this.props.formik.setFieldValue}
                                    errors={this.props.formik.errors.termWeekIds}
                                    touched={this.props.formik.touched.termWeekIds}
                                    isTouched={this.props.formik.setFieldTouched}
                                    setFieldOnlyValue={true}
                                    colourStyles={{
                                        menu: () => ({ zIndex: 999999 })
                                    }}
                                />
                            ) : (
                                <h6 className="not-weekly-text">{T.t('r_not_weekly_course')}</h6>
                            )}
                        </div>
                        <div
                            className={'animated ' + (this.props.formik.values.dateCriteria === 2 ? 'fadeInDown' : 'fadeOutDown')}
                            style={{
                                animationDuration: '0.3s',
                                display: this.props.formik.values.dateCriteria === 2 ? 'block' : 'none',
                            }}
                        >
                            <SelectAsync
                                isMulti={false}
                                isSearchable={true}
                                isClearable={true}
                                requestType={'post'}
                                parameter={{
                                    CourseId: this.props.coursePageActivityId,
                                    classId: this.props.coursePageClassId,
                                    Take: 7,
                                    Skip: 0,
                                    activityId: this.props.isUpdate || null
                                }}
                                placeHolder={T.t('r_select_activity')}
                                url={'api/get/conditionalactivities'}
                                closeMenuOnScroll={false}
                                closeMenuOnSelect={true}
                                column={{ label: 'activityName', value: 'activityId' }}
                                setSelectValue={this.props.isUpdate ? this.props.formik.values.datePrerequisiteActivityId : ''}
                                name={'datePrerequisiteActivityId'}
                                value={this.props.formik.values.datePrerequisiteActivityId}
                                onChange={this.handleDatePrerequisiteActivityId}
                                setFieldValue={this.props.formik.setFieldValue}
                                errors={this.props.formik.errors.datePrerequisiteActivityId}
                                touched={this.props.formik.touched.datePrerequisiteActivityId}
                                isTouched={this.props.formik.setFieldTouched}
                                colourStyles={{
                                    menu: () => ({ zIndex: 999999 })
                                }}
                            />
                        </div>
                    </div>
                    <div
                        className={'animated ' + (this.props.formik.values.dateCriteria === 2 ? 'fadeInDown' : 'fadeOutDown')}
                        style={{
                            animationDuration: '0.3s',
                            display: 'none',
                            padding: '1.8%'
                        }}
                    >
                        <Input type={'number'} name={'datePrerequisiteActivityHours'} label={T.t('r_time')} formik={this.props.formik} value={'0'} />
                    </div>
                </div>
                <div className='d-flex align-items-center mt-3'>
                     <h5 className="input-label mx-0">{T.t('r_activity_finish_criteria')}</h5>
                    <Tooltip data={T.t('r_activity_finish_criteria_info')} position='top' heightValue='2em'>
                        <img src={_common.GetDefaultIcons('info')} style={{ width: '1em',height:'1em', marginInlineStart: "8px"  }} alt="" />
                    </Tooltip>
                </div>
                {this.props && this.props.isUpdate != "" ?
                    <div className="row">
                        {this.props.formik.values.completionType === ActivityCompletionType.View ?
                            <div className="col-md-4">
                                <div className="radio-tabs tick-radio position-relative">
                                    <input
                                        type="radio"
                                        name={'completionType'}
                                        value={ActivityCompletionType.View}
                                        defaultChecked={true}
                                        onChange={this.props.formik.setFieldValue.bind(this, 'completionType', ActivityCompletionType.View)}
                                        id="completion-type-view"
                                        className="form-radio"
                                        checked={this.props.formik.values.completionType === ActivityCompletionType.View ? true : false}
                                    />
                                    <label htmlFor="completion-type-view">{T.t('r_display')}</label>
                                </div>
                            </div>
                            : null}
                    </div>
                    :
                    <div className="row">
                        <div className="col-md-4">
                            <div className="radio-tabs tick-radio position-relative">
                                <input
                                    type="radio"
                                    name={'completionType'}
                                    value={ActivityCompletionType.View}
                                    defaultChecked={true}
                                    onChange={this.props.formik.setFieldValue.bind(this, 'completionType', ActivityCompletionType.View)}
                                    id="completion-type-view"
                                    className="form-radio"
                                    checked={this.props.formik.values.completionType === ActivityCompletionType.View ? true : false}
                                />
                                <label htmlFor="completion-type-view">{T.t('r_display')}</label>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default connect<IProjectActivityAddProps, IOuterProps>(DocumentActivityContent);
